import { NgModule } from '@angular/core';
import { LoginComponent } from './login/login.component';
import { FormComponent } from '@adminprodigydesign/axis';
import { CommonModule } from '@angular/common';
import { PasswordResetComponent } from './password-reset/password-reset.component';
import { RouterModule } from '@angular/router';
import { RegisterSuccessComponent } from './register-success/register-success.component';
import { FormsModule } from '@angular/forms';

@NgModule({
  declarations: [
    LoginComponent,
    PasswordResetComponent,
    RegisterSuccessComponent,
  ],
  imports: [FormComponent, CommonModule, RouterModule, FormsModule],
  exports: [LoginComponent],
})
export class FeaturesModule {}
